import type { KAPLAYCtx } from "kaplay";
import * as C from "./constants";

export interface JumpController {
  handleJumpInput(): void;
  handleJumpRelease(): void;
  update(dt: number): void;
}

export function createJumpController(
  k: KAPLAYCtx,
  player: any,
): JumpController {
  let coyoteTimeRemaining = 0;
  let jumpBufferRemaining = 0;
  let isJumpHeld = false;
  let wasGrounded = player.isGrounded();

  player.onGround(() => {
    coyoteTimeRemaining = C.COYOTE_TIME;
  });

  player.onFall(() => {
    if (coyoteTimeRemaining <= 0) return;
    k.wait(C.COYOTE_TIME, () => {
      coyoteTimeRemaining = 0;
    });
  });

  function executeJump(): boolean {
    if (!player.isAlive) return false;

    const canJump = player.isGrounded() || coyoteTimeRemaining > 0;

    if (canJump) {
      player.jump(C.JUMP_FORCE);
      coyoteTimeRemaining = 0;
      jumpBufferRemaining = 0;
      return true;
    }
    return false;
  }

  return {
    handleJumpInput() {
      isJumpHeld = true;

      if (!executeJump()) {
        jumpBufferRemaining = C.JUMP_BUFFER_TIME;
        k.wait(C.JUMP_BUFFER_TIME, () => {
          jumpBufferRemaining = 0;
        });
      }
    },

    handleJumpRelease() {
      isJumpHeld = false;
    },

    update(dt: number) {
      if (!player.isAlive) return;

      const isCurrentlyGrounded = player.isGrounded();

      // Handle buffered jumps when landing
      if (!wasGrounded && isCurrentlyGrounded && jumpBufferRemaining > 0) {
        executeJump();
      }

      // Handle held jumps when landing (continuous jumping)
      if (!wasGrounded && isCurrentlyGrounded && isJumpHeld) {
        executeJump();
      }

      if (!isCurrentlyGrounded && player.children.length > 0) {
        player.children[0].angle += C.ROTATION_SPEED * dt;
      }

      // Snap to nearest 90 degrees when landing
      if (!wasGrounded && isCurrentlyGrounded && player.children.length > 0) {
        const currentAngle = player.children[0].angle % 360;
        const nearestNinety = Math.round(currentAngle / 90) * 90;
        player.children[0].angle = nearestNinety;
      }

      wasGrounded = isCurrentlyGrounded;

      player.pos.x = C.PLAYER_HORIZONTAL_POSITION * C.GRID_CELL_SIZE;
    },
  };
}
